import { useOnboarding, type OnboardingStep } from "@/hooks/use-onboarding"
import { CURRENT_CLIENT } from "@/constants"
import { onboardingProgressSummary } from "@/lib/onboarding-display"
import { OnboardingWelcomePanel } from "@/components/onboarding/onboarding-welcome-panel"
import type { OnboardingStepNext } from "@/lib/onboarding-step-nav"

interface WelcomeStepProps {
  step: OnboardingStep
  onNext: OnboardingStepNext
  isCompleting: boolean
}

export function WelcomeStep({ step, onNext, isCompleting }: WelcomeStepProps) {
  const { status } = useOnboarding()
  const clientName = CURRENT_CLIENT.name || 'Yes Human'
  const tagline = CURRENT_CLIENT.tagline?.trim()
  const steps = status?.steps ?? []
  const completedIds = status?.completed_step_ids ?? []
  const progressSummary = onboardingProgressSummary(steps, completedIds)

  return (
    <OnboardingWelcomePanel
      variant="page"
      title={step.title.replace('{client_name}', clientName)}
      description={step.description}
      tagline={tagline}
      completed={progressSummary.completed}
      total={progressSummary.total}
      percent={progressSummary.percent}
      onContinue={onNext}
      isContinuing={isCompleting}
    />
  )
}
